import React from 'react'
import styles from './ExecutiveSummary.module.css'
import ExecutiveSummaryHeader from './ExecutiveSummaryHeader'
import ExecutiveSummaryMetrics from './ExecutiveSummaryMetrics'
import ExecutiveSummaryWeekly from './ExecutiveSummaryWeekly'
import ExecutiveSummaryPillar from './ExecutiveSummaryPillar'

export { default as ExecutiveSummaryHeader } from './ExecutiveSummaryHeader'
export { default as ExecutiveSummaryMetrics } from './ExecutiveSummaryMetrics'
export { default as ExecutiveSummaryWeekly } from './ExecutiveSummaryWeekly'
export { default as ExecutiveSummaryPillar } from './ExecutiveSummaryPillar'

const ExecutiveSummary = (props) => {
  const data = props.data || {}
  const overall = data.overall_assessment || null

  // Don't render if no data at all
  if (!data || Object.keys(data).length === 0) {
    return null
  }

  return (
    <div className={styles.container}>
      {/* Header - Overall Assessment */}
      {overall && <ExecutiveSummaryHeader overall={overall} />}

      {/* Key Metrics to Track */}
      {data.key_metrics_to_track && (
        <div className={styles.sectionCard}>
          <h2 className={styles.sectionTitle}>
            <span role="img" aria-label="trophy">🏆</span>
            Key Metrics to Improve — Current vs Target
          </h2>
          <ExecutiveSummaryMetrics metrics={data.key_metrics_to_track} />
        </div>
      )}

      {/* Weekly Priorities & Focus */}
      {data.weekly_structure && (
        <div className={styles.sectionCard}>
          <h2 className={styles.sectionTitle}>
            <span role="img" aria-label="calendar">📅</span>
            Weekly Priorities & Focus
          </h2>
          <ExecutiveSummaryWeekly weeklyStructure={data.weekly_structure} />
        </div>
      )}

      {/* Three Pillars */}
      {(data.exercise || data.nutrition || data.sleep) && (
        <div className={styles.pillarsGrid}>
          {data.exercise && (
            <ExecutiveSummaryPillar pillarKey="exercise" title="Exercise" pillarData={data.exercise} />
          )}
          {data.nutrition && (
            <ExecutiveSummaryPillar pillarKey="nutrition" title="Nutrition" pillarData={data.nutrition} />
          )}
          {data.sleep && (
            <ExecutiveSummaryPillar pillarKey="sleep" title="Sleep" pillarData={data.sleep} />
          )}
        </div>
      )}

      {/* Next Steps */}
      {data.next_steps && data.next_steps.length > 0 && (
        <div className={styles.sectionCard}>
          <h2 className={styles.sectionTitle}>
            <span role="img" aria-label="target">🎯</span>
            Next Steps — Prioritized Actions
          </h2>
          <ol className={styles.nextStepsList}>
            {data.next_steps.map((step, idx) => (
              <li key={idx} className={styles.nextStepItem}>
                <span
                  className={styles.nextStepNumber}
                  style={{ backgroundColor: ['#f5222d', '#faad14', '#52c41a', '#1677ff'][idx] || '#1677ff' }}
                >
                  {idx + 1}
                </span>
                {step}
                <div className={styles.nextStepMeta}>Start within 48 hours · Review in 7 days</div>
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  )
}

export default ExecutiveSummary
